module.exports = __webpack_public_path__ + "static/media/faq_1.b0d2c7d9.png";